import claims from './claims';

export default {
  ...claims,
  'insurance': 'Assurance',
  'insuranceData': 'Données d\'Assurance',
};